import React from "react";
import PatientCard from "../../components/Patient/partial/PatientCard";
import { cleanDate } from "../../util/app";

const DueCarePlanList = ({ items = [] }) => {
    if (items.length)
        return (
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: "5%" }}>
                            SN
                        </th>
                        <th style={{ width: "40%" }}>Patient</th>
                        <th style={{ width: "25%" }}>Careplan</th>
                        <th style={{ width: "25%" }}>Review Date & Time</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, idx) => (
                        <tr>
                            <td className="text-center">{idx + 1}</td>
                            <td>
                                <PatientCard item={item.patient} />
                            </td>
                            <td>
                                <strong>Title</strong>: {item.header.title}
                            </td>
                            <td>{cleanDate(item.evaluation.nextDate, false, true)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );

    return (
        <>
            <div className="text-center">
                <h4>No Careplan is due for review!</h4>
            </div>
        </>
    );
};

export default DueCarePlanList;
